export default __webpack_public_path__ + "static/media/network.f37a1424.png";